export default __webpack_public_path__ + "static/media/dharma-elektrindo.af7ba763.png";